/* eslint-disable camelcase */
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getSESProducts = (query) => {
  const { itemsPerPage, currentPage, sortBy, sortOrder, keyword, id, stats_display, stats_start_date, stats_end_date, has_orders, has_pending_orders, suppliers, status, export_ggsheet, export_supplier, safe_week, export_sort } = query;
  const itemOffset = (currentPage - 1) * itemsPerPage;
  
  let queryString = `&limit=${itemsPerPage || 20}&skip=${itemOffset || 0}`;

  if (sortBy) {
    const sortDirection = sortOrder < 0 ? '-' : '';
    queryString += `&sort=${sortDirection}${sortBy}`;
  }
  
  if (keyword) {
    queryString += `&keyword=${keyword}`;
  }

  if (id) {
    queryString += `&_id=${id}`;
  }

  if (stats_display !== undefined) {
    queryString += `&stats_display=${stats_display}`;
  }

  if (stats_start_date) {
    queryString += `&stats_start_date=${stats_start_date}`;
  }

  if (stats_end_date) {
    queryString += `&stats_end_date=${stats_end_date}`;
  }

  if (has_orders !== undefined) {
    queryString += `&has_orders=${has_orders}`;
  }

  if (has_pending_orders !== undefined) {
    queryString += `&has_pending_orders=${has_pending_orders}`;
  }

  if (suppliers) {
    queryString += `&suppliers=${suppliers}`;
  }

  if (status) {
    queryString += `&status=${status}`;
  }

  if (export_ggsheet) {
    queryString += `&export_ggsheet=${export_ggsheet}`;
  }
  if (export_supplier) {
    queryString += `&export_supplier=${export_supplier}`;
  }
  if (safe_week) {
    queryString += `&safe_week=${safe_week}`;
  }
  if (export_sort) {
    queryString += `&export_sort=${export_sort}`;
  }

  queryString = "?" + queryString;

  queryString = queryString.replace("?&", "?");

  return API.get(`${getApiUrl()}/api/ses/product${queryString}`);
};

export const getSESProductById = (id) => {
  return API.get(`${getApiUrl()}/api/ses/product/${id}`);
};

export const setSESProducts = (products, query = {}) => {
  const { generate_version } = query;
  let queryString = ''; 
  
  if (generate_version) {
    // queryString = `?generate_version=${generate_version}`;
  }

  return API.post(`${getApiUrl()}/api/ses/product${queryString}`, products);
};

export const updateSESProduct = (id, product) => {
  return API.put(`${getApiUrl()}/api/ses/product/${id}`, product);
};

export const deleteSESProduct = (id) => {
  return API.delete(`${getApiUrl()}/api/ses/product/${id}`);
};

export const getProductByVersion = (product_code, query = {}) => {
  const { version, friendly_version } = query;
  let queryString = `product_code=${product_code}`;

  if (version) {
    queryString += `&version=${version}`;
  }

  if (friendly_version) {
    queryString += `&friendly_version=${friendly_version}`;
  }

  const url = `${getApiUrl()}/api/ses/product-versions?${queryString}`;
  return API.get(url);
};

export const sesProductService = {
  getSESProducts,
  getSESProductById,
  setSESProducts,
  updateSESProduct,
  deleteSESProduct,
  getProductByVersion
}; 